// Polyfills that need to be loaded before anything else
import { Buffer } from 'buffer';
import process from 'process';

// Make Buffer and process available globally
if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  window.global = window;
  window.process = process;
  
  // Additional polyfills for crypto libraries
  if (!window.global.Buffer) {
    window.global.Buffer = Buffer;
  }
  if (!window.global.process) {
    window.global.process = process;
  }
}
